<div class="jbm-document-viewer iframe-container">
   <iframe *ngIf="url" [src]="url"></iframe>
</div>